import axios from "axios";
import API from "../_helpers/endpointService";
import moment from "moment"
export const getprojectshipdocinfo = (data, id) => {
  let apiUrl = API.SHIP_DOCUMENT + id + '?Name=' + data.Name + '&Top=' + data.Top + '&PageNo=' + data.PageNo + '&PageSize=' + data.PageSize
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "SHIP_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const addshipdocumentinfo = (data, id, modify) => {
  let apiUrl = API.SHIP_DOCUMENT + id + '?modify=' + modify
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "UPLOAD_DOCS", data: [] });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const deletemulitishipdocs = (data, id) => {
  let ids = "";
  if (data && data.length > 0) {
    data.map((val, index) => {
      if (index == 0) {
        ids += "ids=" + val.data;
      }
      else {
        ids += "&ids=" + val.data;
      }
    })
  }
  let apiUrl = API.SHIP_DOCUMENT + 'ids?' + ids;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "delete",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const downloadsingleshipdocs = (data) => {
  let apiUrl = API.SHIP_DOCUMENT + data.DocumentId + '/Document';
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "get",
      url: apiUrl,
      responseType: "blob",
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          let blob = new Blob([response.data]);
          let url = URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = data.DocumentName;
          a.click();
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const downloadmultipleshipdocs = (data) => {
  let keys = "";
  if (data && data.length > 0) {
    data.map((val, index) => {
      if (index == 0) {
        keys += "keys=" + val.objectkey;
      }
      else {
        keys += "&keys=" + val.objectkey;
      }
    })
  }
  let apiUrl = API.SHIP_DOCUMENT + 'keys?' + keys;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "get",
      url: apiUrl,
      responseType: "blob",
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          let blob = new Blob([response.data]);
          let url = URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = "Ship Document.zip"
          a.click();
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const gethistorylogshipdocinfo = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=ShipDocument'
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "HISTORY_LOG", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};